export interface UsageBlock {
  used: number;
  total: number;
  baseTotal: number;
  extras: number;
  percentage: number;
}

export interface TaxPayerUsage {
  period: "monthly" | "yearly";
  year: number;
  month: number | null;
  des: UsageBlock;
  receipts?: UsageBlock;
}

export interface TaxPayerSpecialPermissions {
  whatsappEnabled: boolean;
}

export interface TaxPayerSuspensionSummary {
  reasonCode: string;
  reasonName: string;
  message: string;
  suspendedAt: string;
}

interface TaxPayer {
  id?: number;
  ruc?: string;
  socialName?: string;
  fantasyName?: string;
  type?: string;
  regimeTypeId?: number;
  isActive?: boolean;
  isDemo?: boolean;
  whatsappEnabled?: boolean;
  createdAt?: string;
  usage?: TaxPayerUsage;
  suspension?: TaxPayerSuspensionSummary;
}

export const TAX_PAYER_TYPE_PERSON = "person";
export const TAX_PAYER_TYPE_ENTITY = "entity";
export const TAX_PAYER_TYPE_PERSON_LABEL = "Persona";
export const TAX_PAYER_TYPE_ENTITY_LABEL = "Entidad";

export const TAX_PAYER_TYPE_CHOICES: Map<string, string> = new Map([
  [TAX_PAYER_TYPE_PERSON, TAX_PAYER_TYPE_PERSON_LABEL],
  [TAX_PAYER_TYPE_ENTITY, TAX_PAYER_TYPE_ENTITY_LABEL],
]);

export const newTaxPayer = (): TaxPayer => {
  return {};
};

export default TaxPayer;
